export default __webpack_public_path__ + "static/media/Weather2.a58458cb.png";